import { attendanceTypeRepo } from '../../helpers/hrms_backend/repositories'

export const state = {
  attendance_types: [],
  current_attendance_type: {
    type: '',
    name: '',
    is_active: true,
  },
}

export const getters = {
  attendance_types(state) {
    return state.attendance_types
  },
  current_attendance_type(state) {
    return state.current_attendance_type
  },
}

export const mutations = {
  SET_ATTENDANCE_TYPES(state, newValue) {
    state.attendance_types = newValue
  },
  SET_CURRENT_ATTENDANCE_TYPE(state, newValue) {
    state.current_attendance_type = newValue
  },
}

export const actions = {
  // Get AttendanceTypes.
  getAttendanceTypes({ commit, dispatch }, id) {
    return attendanceTypeRepo.get(id).then(
      (response) => {
        if (id) {
          commit('SET_CURRENT_ATTENDANCE_TYPE', response.data)
        } else {
          commit('SET_ATTENDANCE_TYPES', response.data)
        }
        return response.data
      },
      (error) => {
        const message = error?.response?.data?.message ?? error
        dispatch('notification/error', message, { root: true })
      }
    )
  },
  // Create AttendanceType.
  createAttendanceType({ commit, dispatch }, attendance_type) {
    return attendanceTypeRepo.post(attendance_type).then(
      (response) => {
        dispatch('notification/error', null, { root: true })
        if (response.data?.success) {
          commit('SET_CURRENT_ATTENDANCE_TYPE', response.data.data)
          if (attendance_type.id) {
            commit(
              'SET_ATTENDANCE_TYPES',
              state.attendance_types.map((j) => {
                if (parseInt(j.id) === parseInt(attendance_type.id)) {
                  return response.data.data
                }
                return j
              })
            )
          } else {
            commit('SET_ATTENDANCE_TYPES', [
              ...state.attendance_types,
              response.data.data,
            ])
          }
        }
        return response.data
      },
      (error) => {
        const message = error?.response?.data?.message ?? error
        dispatch('notification/error', message, { root: true })
      }
    )
  },
  // Delete AttendanceType.
  deleteAttendanceType({ commit, dispatch }, id) {
    return attendanceTypeRepo.destroy(id).then(
      (response) => {
        dispatch('notification/error', null, { root: true })
        commit('SET_CURRENT_ATTENDANCE_TYPE', {})
        return response.data
      },
      (error) => {
        const message = error?.response?.data?.message ?? error
        dispatch('notification/error', message, { root: true })
      }
    )
  },
}
